/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Vue from 'vue';
import { ls } from '@/utils/localStorageTtl';
import {
  CHECK,
  REGISTER,
  LOGIN,
  LOGOUT,
} from './mutation-types';
/* eslint-disable no-param-reassign */
export default {
  [CHECK](state) {
    try {
      state.authenticated = !!ls.get('id_token');

      if (ls.get('user')) {
        state.user = JSON.parse(ls.get('user'));
      }

      if (state.authenticated) {
        Vue.axios.defaults.headers.common.Authorization = `Bearer ${ls.get('id_token')}`;
      } else {
        // remove because of ttl expired
        localStorage.removeItem('id_token');
        localStorage.removeItem('user');
        localStorage.removeItem('vue-authenticate.vueauth_token');
        Vue.axios.defaults.headers.common.Authorization = '';
      }
    } catch (err) {
      // remove because of parsing error
      state.authenticated = false;
      state.user = {};
      localStorage.removeItem('id_token');
      localStorage.removeItem('user');
      localStorage.removeItem('vue-authenticate.vueauth_token');
      Vue.axios.defaults.headers.common.Authorization = '';
    }
  },

  [REGISTER]() {
    //
  },

  [LOGIN](state, payload) {
    state.authenticated = true;
    state.user = payload.user;
    ls.set('id_token', payload.token, payload.ttl);
    ls.set('user', JSON.stringify(payload.user), payload.ttl);
    Vue.axios.defaults.headers.common.Authorization = `Bearer ${payload.token}`;
  },

  [LOGOUT](state) {
    state.authenticated = false;
    state.user = null;
    localStorage.removeItem('id_token');
    localStorage.removeItem('user');
    localStorage.removeItem('vue-authenticate.vueauth_token');
    Vue.axios.defaults.headers.common.Authorization = '';
    Vue.router.push({
      name: 'login.index',
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js